import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

//modus pictures
import autoAut from "../../../../assets/images/mgsuite/Automatic_24x24.png";
import autoOcc from "../../../../assets/images/mgsuite/ManualOccupied_24x24.png";
import autoFree from "../../../../assets/images/mgsuite/ManualFree_24x24.png";

const AreaSettingsModus = forwardRef((props, ref) => {
  let jwt = localStorage.getItem("JWT");
  let link = localStorage.getItem("link");

  const { data, type: settingsType } = props;
  const { t } = useTranslation();
  const [mode, setMode] = useState(null);
  const [originalMode, setOriginalMode] = useState(null);
  const [saving, setSaving] = useState(false);

  const isDirty = () => mode !== originalMode;

  const save = async () => {
    if (!isDirty() || saving) return;

    setSaving(true);
    try {
      await axios.put(
        link + "/api/" + settingsType + "/Mode?mode=" + mode,
        data.ids,
        {},
      );

      setOriginalMode(mode);
    } finally {
      setSaving(false);
    }
  };

  const reset = () => {
    setMode(originalMode);
  };

  // useEffect(() => {
  //   if (data?.mode !== undefined) {
  //     const m = String(data.mode);
  //     setMode(m);
  //     setOriginalMode(m);
  //   }
  // }, [props.data]);

  useImperativeHandle(ref, () => ({
    save,
    reset,
    isDirty,
  }));

  const onChangeMode = (newMode) => {
    setMode(newMode);
  };

  return (
    <div className="settings-groups">
      <div className="settings-name">{t("allgemein.modus")}</div>
      <div className="label-container">
        <label class="input-container">
          <input
            type="radio"
            id="mode-automatic"
            checked={mode === "0"}
            name="radio-car"
            className="input-element"
            onChange={() => onChangeMode("0")}
          />
          <img src={autoAut} className="settings-img" />{" "}
          {t("lot.modes.Automatic")}
        </label>
      </div>
      <div className="label-container">
        <label class="input-container">
          <input
            type="radio"
            id="mode-manual-free"
            checked={mode === "1"}
            name="radio-car"
            className="input-element"
            onChange={() => onChangeMode("1")}
          />
          <img src={autoFree} className="settings-img" />{" "}
          {t("lot.modes.ManualFree")}
        </label>
      </div>
      <div className="label-container">
        <label class="input-container">
          <input
            type="radio"
            id="mode-manual-occupied"
            checked={mode === "2"}
            name="radio-car"
            className="input-element"
            onChange={() => onChangeMode("2")}
          />
          <img src={autoOcc} className="settings-img" />{" "}
          {t("lot.modes.ManualOccupied")}
        </label>
      </div>
    </div>
  );
});

export default AreaSettingsModus;
